import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";

// ------------------ COMPONENTES DE BASE--------------------------
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../Base/Services/ToastService";
import { getLabel } from "../../../Base/Services/Language/LanguageService";
import { getDateProduction } from "../../../Base/Services/FechasService";
import { ConfigContext } from "../../../Base/Context/ConfigContext/ConfigContext";
import { baseLang } from "../../../Base/Lang/BaseLang";
import { setTitlePage } from "../../../Base/Services/Config/ConfigService";
import Card from "../../../Base/Components/Card/Card";
import CalendarioOperativo from "../../../Base/Components/Form/CalendarioOperativo";
import AgGrid from "../../../Base/Components/Tables/AgGrid/AgGrid";
import { eliminarBoleta, getBoletaCompra } from "../../../API/Finanzas/CajaChica/BoletaCompraRequest";
import BoletaCompraCRUD from "./BoletaCompraCRUD";
import { confirmDialog } from "primereact/confirmdialog";

// ------------------- CONSULTAS A LA API---------------------------

// ------------------ COMPONENTES DE NECESARIOS--------------------------

const BoletaCompraScreen = () => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);

  const [listadoEnc, setListadoEnc] = useState([]);

  const [loading, setLoading] = useState(false);
  const [dates, setDates] = useState([new Date(), new Date()]);
  const [showDialog, setShowDialog] = useState(false);
  const [selectedEnc, setSelectedEnc] = useState([]);
  const [habilitar, setHabilitar] = useState(true);
  

  const getInfo = async () => {
    if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
      toastShow( toast, "warn", "Advertencia", "Por favor, seleccione un rango de fechas válido." );
      return;
    }
    setLoading(true);
    const fechas = getDateProduction(dates);

    const dataTempo = await getBoletaCompra(fechas)
    setListadoEnc(dataTempo)

    setLoading(false);
  };

  const EliminarBoletas = async () => {
    confirmDialog({
      message: selectedEnc?.length > 1 ? "¿Está seguro que desea eliminar las boletas de compra?" : "¿Está seguro que desea eliminar la boleta de compra?",
      header: "Eliminar Boleta",
      icon: "pi pi-exclamation-triangle",
      accept: async () => {
        setLoading(true);
        // const Ids = selectedEnc.filter(item => item.IdBoletaCompraEnc > 0).map(item => item.IdBoletaCompraEnc).join(',');
        let Ids = selectedEnc[0]?.IdBoletaCompraEnc
        let IdRango = selectedEnc[0]?.IdRangoBoletaCompra
        const resp = await eliminarBoleta(Ids, IdRango);
        toastShow(toast, "success", "Eliminado", selectedEnc?.length > 1 ? 'Boletas eliminadas correctamente' : 'Boleta eliminada correctamente');
        setTimeout(() => {            
          setLoading(false);
          getInfo()
          setSelectedEnc([]);
        }, 600);
      },
      reject: () => {},
    })
  };

  const columns = [
    {
      field: "IdBoletaCompraEnc",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      frozen: 1,
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdBoletaCompraEnc > 0) {
          setShowDialog(true);
          setSelectedEnc([data]);
        }
      },
    },
    {
      field: "FechaEmisionStr",
      header: "Fecaha Emisión",
      headerEn: "Date Emission",
      Format: "Date",
      frozen: 1,
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdNotaCreditoEnc > 0) {
          setShowDialog(true);
          setSelectedEnc([data]);
        }
      },
    },
    {
      field: "NumeroBoletaCompra",
      headerEn: "No. Boleta",
      header: "No. Boleta",
      frozen: 1,
      className: "medium",
      Format: "Modal",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdBoletaCompraEnc > 0) {
          setShowDialog(true);
          setSelectedEnc([data]);
        }
      },
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      frozen: 1,
      className: "medium",
      Format: "Estado",
      body: (rowData) => ({
        ID: rowData.IdStatus,
        Estado: rowData.StatusName,
      }),
    },
    {
      field: "CustomerName",
      header: "Proveedor",
      headerEn: "Supplier",
      className: "XXXlarge",
    },
    {
      field: "NombreCuenta",
      header: "Cuenta",
      headerEn: "Account",
      className: "XXlarge",
    },
    {
      field: "Currency",
      header: "Moneda",
      headerEn: "Currency",
      className: "small",
    },
    {
      field: "OrdenCompra",
      header: "Orden de Compra",
      headerEn: "Purchase Order",
      className: "medium",
    },
    {
      field: "ConstanciaRegistro",
      header: "Constancia de Registro",
      headerEn: "Registration Certificate",
      className: "medium",
    },
    {
      field: "RegistroSAG",
      header: "Registro SAG",
      headerEn: "SAG Registration",
      className: "medium",
    },
    {
      header: "Comentario",
      headerEn: "Comment",
      field: "Comentario",
      minWidth: 300,
    },
    {
      field: "TasaCambio",
      header: "Tasa Cambio",
      headerEn: "Rate Change",
      className: "Xsmall",
      Format: "Currency",
      Sumary: "sum",
    },
    {
      field: "TotalL",
      header: "Total L",
      headerEn: "Total L",
      className: "small",
      Format: "Currency",
      Sumary: "sum",
      Frozen: true,
      alignFrozen: "right",
    },
    {
      field: "TotalD",
      header: "Total $",
      headerEn: "Total $",
      className: "small",
      Format: "Currency",
      Sumary: "sum",
      Frozen: true,
      alignFrozen: "right",
    },
    {
      field: "IdBoletaCompraEnc",
      header: "",
      Format: "Botones",
      filter: false,
      frozen: 1,
      alignFrozen: "right",
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          tooltipOptions: { position: "left" },
          onClick: (rowData) => {
            if (rowData?.IdBoletaCompraEnc > 0) {
              setShowDialog(true);
              setSelectedEnc([rowData]);
            }
          },
        },
      ],
    },
  ];

  const table = {
    Columns: columns,
    Data: listadoEnc,
    loading: loading,
    selected: selectedEnc,
    setSelected: setSelectedEnc,
    showModal: () => {},
  };

  useEffect(() => {
    getInfo();
    setTitlePage(getLabel(baseLang, "Boleta de Compra", config.language));
  }, []);

  return (
    <div>
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones flex-wrap">
            <h3 style={{marginTop: 6}}>{getLabel(baseLang, "Boleta de Compra", config.language)}</h3>
            <CalendarioOperativo
              dates={dates}
              setDates={setDates}
              loading={loading}
              getInfo={getInfo}
            />
            <Button
              icon="pi pi-refresh"
              tooltip="Buscar"
              onClick={() => getInfo()}
            />
            <Button
              icon="pi pi-plus"
              tooltip="Nueva"
              onClick={(e) => setShowDialog(true)}
            />
            <Button
              severity="danger"
              icon="pi pi-times"
              tooltip="Nueva"
              onClick={EliminarBoletas}
              disabled={selectedEnc?.length !== 1}
            />
          </div>
        }
        contenido={
          <div style={{marginTop: 40}}>
            <div style={{height: '87vh'}}>
                <AgGrid table={table} />
            </div>
          </div>
        }
      />

      {showDialog && (
        <BoletaCompraCRUD
          showDialog={showDialog}
          setShowDialog={setShowDialog}
          selectedEnc={selectedEnc}
          setSelectedEnc={setSelectedEnc}
          getInfo={getInfo}
          habilitar={habilitar}
          setHabilitar={setHabilitar}
        />
      )}
    </div>
  );
};

export default BoletaCompraScreen;
